<template>
  <div class="template-item">
    <div class="email-header" @click="$emit('toggle')">
      <div class="info">
        <h5>{{ template.title }}</h5>
        <p>{{ template.description }}</p>
      </div>

      <i v-if="!isEditMode && isOpen" style="margin-right: 8px;" class="fa fa-edit" @click.stop="enableEdit"></i>
      <span :class="{ rotate: isOpen }">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </span>
    </div>

    <transition name="collapse">
      <div v-if="isOpen" class="content">
        <AvailableVariables v-if="isEditMode" :variables="template.variables" @insert="insertVariable" />

        <div class="field">
          <label>Subject</label>
          <input type="text" v-model="localSubject" :disabled="!isEditMode" ref="subjectInput" />
        </div>

        <div class="field">
          <label>Email Body</label>
          <textarea rows="14" v-model="localBody" :disabled="!isEditMode" ref="bodyInput"></textarea>
        </div>

        <div v-if="isEditMode" style="margin-block: 12px; padding: 12px; background-color: #fefce8; border-radius: 8px; font-size: 12px; border: 1px solid #f9f4c7;">
          <p style="font-size: 11px; color: #a57b4b; margin-bottom: 0px;">
            <strong style="font-weight: bolder; color: #9b7244;">Note:</strong> Click the variable buttons above to insert them at your cursor position. All variables will be automatically replaced with actual data when email is sent.
          </p>
        </div>

        <div class="actions">
          <template v-if="isEditMode">
            <button class="secondary-button" @click="cancelEdit">Cancel</button>
            <button class="primary-button" @click="saveTemplate">Save Template</button>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import AvailableVariables from "./AvailableVariables.vue";

export default {
  components: { AvailableVariables },

  props: {
    template: Object,
    isOpen: Boolean
  },

  data() {
    return {
      isEditMode: false,
      localSubject: "",
      localBody: "",
      activeField: null
    };
  },

  watch: {
    isOpen(val) {
      if (val) {
        this.resetValues();
      }
    }
  },

  methods: {
    resetValues() {
      this.isEditMode = false;
      this.localSubject = this.template.subject;
      this.localBody = this.template.body;
    },

    enableEdit() {
      this.isEditMode = true;
    },

    cancelEdit() {
      this.resetValues();
    },

    saveTemplate() {
      const payload = {
        ...this.template,
        subject: this.localSubject,
        body: this.localBody
      };

      this.$emit("save", payload);
      this.isEditMode = false;
    },

    insertVariable(variable) {
      const ref =
        this.activeField === "subject"
          ? this.$refs.subjectInput
          : this.$refs.bodyInput;

      if (!ref) return;

      const start = ref.selectionStart;
      const end = ref.selectionEnd;
      const value =
        this.activeField === "subject"
          ? this.localSubject
          : this.localBody;

      const updated =
        value.slice(0, start) +
        variable +
        value.slice(end);

      if (this.activeField === "subject") {
        this.localSubject = updated;
      } else {
        this.localBody = updated;
      }

      this.$nextTick(() => {
        ref.focus();
        ref.selectionStart = ref.selectionEnd =
          start + variable.length;
      });
    }
  },

  mounted() {
    this.$refs.subjectInput.addEventListener("focus", () => {
      this.activeField = "subject";
    });
    this.$refs.bodyInput.addEventListener("focus", () => {
      this.activeField = "body";
    });
  }
};
</script>

<style scoped>
.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.3s ease;
}

.collapse-enter,
.collapse-leave-to {
  opacity: 0;
  max-height: 0;
}

.collapse-enter-to,
.collapse-leave {
  opacity: 1;
  max-height: 500px;
}

.info {
  display: flex;
  flex-direction: column;
  flex: 1;

  h5 {
    margin-bottom: 1px;
  }
}

.edit-button {
  background: #2563eb;
  color: white;
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 12px;
}

h5 {
  font-size: 14px;
  font-weight: 600;
}

p {
  font-size: 12px;
  font-weight: 600;
  color: #7b7b7b;
}

.template-item {
  border: 1px solid #ddd;
  margin-bottom: 12px;
  border-radius: 10px;
}

span {
  transition: transform 0.3s ease;
}

.rotate {
  transform: rotate(180deg);
}


.email-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 10px;

  p {
    margin-bottom: 0px;
  }
}

.content {
  padding: 12px;
}

.field {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  label {
    margin-bottom: 4px;
    font-weight: 600;
    font-size: 12px;
  }

  input {
    font-size: 12px;
    font-weight: 600;
    padding: 10px 8px;
    border: 1px solid #f4eafe;
    border-radius: 4px;
    background-color: #faf5ff;
  }

  textarea {
    font-size: 12px;
    font-weight: 500;
    padding: 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #F9FAFB;
    resize: vertical;
    ;
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.primary-button {
        background-color: #5d7974;
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
        font-weight: 500;
        min-width: 80px;
        transition: background-color 0.5s, color 0.3s;
        border: 1px solid #5d7974;
    }

    .primary-button:hover {
        background-color: #7f9b96;
    }

    .secondary-button {
        background-color: transparent;
        color: #000;
        border: 1px solid #ddd;
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.5s, color 0.3s;
        border: 1px solid #5d7974;
    }

    .secondary-button:hover {
        background-color: #f0f0f0;
    }
</style>



// WEBPACK FOOTER //
// src/components/EmailTemplate/EmailTemplateItem.vue